(function ($) {

    ///////////////      INITIALIZATION     //////////////////////
    this.init = function () {

        // set up keyboard nav
        configureMobileKeyNav();

        // attach event handlers
        $(".mobilenav-nav a.level1-item-link-a, .mobilenav-nav .level2-item-link-a").keydown(handleMobileKeyboard);
        $("#mobile-menu-open").click(toggleMobileNav);

//        $(".level2-collapse-open, .level2-collapse-closed").on("click", handleClicksToMobileExpandCollapse);

        $(window).on("resize", hideMobileNav);

        initMobileNav();
    };
    function initMobileNav() {

        var $parentLevel1,
            $parentLevel2;


        $('.mobile-nav .haschildren>a').on("click",function (e) {
            e.stopPropagation();
        });

        $(".mobile-nav .level1-item-link-a, .level2-item-link-a").attr("aria-expanded", false);

        $('.mobilenav-nav .level1-item-link-a.haschildren').on("click", function (e) { // Level 1 clicks
            $parentLevel1 = $(this).closest(".level1-item");

            $parentLevel1.siblings('.open').removeClass('open')
                .find('.level2').slideUp(250, 'swing', null)
                .find('.level2-item.haschildren.open').removeClass('open')
                .find('.level3').slideUp(250, 'swing', null);

            $(".mobilenav-nav .level1-item-link-a").attr("aria-expanded", false);

            if (!$parentLevel1.hasClass('open')) {
                e.preventDefault();
                $parentLevel1.addClass('open').find('> .level2').slideDown(250, 'swing', null);
                $parentLevel1.find(".level1-item-link-a").attr("aria-expanded", true);

            } else if ($parentLevel1.hasClass('open')) {
                $parentLevel1.removeClass('open');
                $parentLevel1.find('.level2').slideUp(250, 'swing', null)
                    .find('.level2-item.haschildren.open').removeClass('open')
                    .find('.level3').slideUp(250, 'swing', null);
            }
            // wether you are opening or closing a level 1 link, make sure all level 2 are closed
            $(".level2-item").each(function () {
                $(this).removeClass("open");
                $(this).find(".level2-item-link-a").attr("aria-expanded", false);
            });
        });
        $('.mobilenav-nav .level2-item-link-a.haschildren').on("click", function (e) { // Level 2 clicks
            $parentLevel2 = $(this).closest(".level2-item");
            console.log($parentLevel2, $parentLevel2.length);
            $(".mobilenav-nav .level2-item-link-a").attr("aria-expanded", false);

            $parentLevel2.siblings('.open').removeClass('open')
                .find('.level3').slideUp(250, 'swing', null);
            if (!$parentLevel2.hasClass('open')) {
                e.preventDefault();
                $parentLevel2.addClass('open')
                    .find('.level3')
                    .slideDown(250, 'swing', null);

                $parentLevel2.find(".level2-item-link-a").attr("aria-expanded", true);

            } else {
                $parentLevel2.find(".level2-item-link-a").attr("aria-expanded", false);
                $parentLevel2.removeClass("open");
                $parentLevel2.find('.level3').slideUp(250, 'swing', null);
            }
        });
    }


    ///////////////      KEYBOARD NAV      ///////////////////////
    function handleMobileKeyboard(event) {


        if (event.which === 37) {
            // left - if this item is open, we close it.
            if (!$(event.currentTarget).parent().parent().hasClass("Open")) {
                if ($(event.currentTarget).parent().find(".haschildren").length > 0) {
                    $(event.currentTarget).parent().find(".haschildren")[0].click();
                } else if ($(event.currentTarget).parent().find(".haschildren").length > 0) {
                    $(event.currentTarget).parent().find(".haschildren")[0].click();
                }

            }
            event.preventDefault();

        } else if (event.which === 39) {
            // right - if this item is closed, open it.
            if (!$(event.currentTarget).parent().parent().hasClass("Open")) {
                if ($(event.currentTarget).parent().find(".haschildren").length > 0) {
                    $(event.currentTarget).parent().find(".haschildren")[0].click();
                } else if ($(event.currentTarget).parent().find(".haschildren").length > 0) {
                    $(event.currentTarget).parent().find(".haschildren")[0].click();
                }
            }
            event.preventDefault();

        } else if (event.which === 27) {
            $("#mobile-menu-open")[0].click();
        }
    }


    function configureMobileKeyNav() {

        var $this, $that, $thisLink, $thatLink;

        var $mobileNav = $(".mobilenav-nav");

        $mobileNav.find(".level1-item").each(function (index) {
            $this = $(this);

            $thisLink = $this.find("a.level1-item-link-a");


            // set up the aria label on level 1 links
            if (index === 0) {
                $thisLink.attr("aria-label", "Top Level Menu Item: " + $thisLink.text() + ". To use nav, press right arrow key to expand submenu items. Press left to close. Use Tab and shift tab to navigate to next and previous items. Press escape to exit nav");
            } else {
                $thisLink.attr("aria-label", "Top Level Menu Item: " + $thisLink.text() + " with " + $this.find(".level2-item").length + " children");
            }

            // hide the + or - if there are no children

            $this.find(".level2-item").each(function (jindex) {
                $that = $(this);
                $thatLink = $that.find(".level2-item-link-a");

                $thatLink.attr("aria-label", "Second Level Menu Item: " + $thatLink.text() + " with " + $that.find(".level3-item").length + " children");

                if (!$that.hasClass("haschildren")) {
                    $this.find(".level2-collapse").remove();
                }

                $that.find(".level3-item").each(function () {

                    $(this).find("a").attr("aria-label", "Third Level Menu Item: " + $(this).find("a").text());

                });

            });

        });
    }

    //////////////        FOCUS HANDLING   ///////////////////////


    //////////////       UTILITY       ///////////////////////
    function stopThaProp(event) {
        event.stopPropagation();
    }
    function hideMobileNav() {
        $(".mobilenav-nav").hide().removeClass("shown");
        $("#mobile-menu-open").removeClass("open");
        setTimeout(function () {
            $("#mobile-nav").removeClass("shown");
        }, 350);

        // stop scroll prop on the header
        $(".mobilenav").off("scroll", stopThaProp);

        $("body").removeClass("hashamburgeroverlay");
        $(".mobilenav").removeClass("hamburgeropen");
        $(".header").removeClass("hamburgeropen");

    }

    function showMobileNav() {
        $(".mobilenav-nav").show();
        $("#mobile-menu-open").addClass("open");
        setTimeout(function () {
            $(".mobilenav-nav").addClass("shown");
        }, 50);

        $("body").addClass("hashamburgeroverlay");
        $(".mobilenav").addClass("hamburgeropen");
        $(".header").addClass("hamburgeropen");
    }

    function toggleMobileNav() {

        if ($(".mobilenav-nav").css("display") === "none") {
            showMobileNav();
        } else {
            hideMobileNav();
        }
    }
    this.init();

})(jQuery);

